import React from "react";

const RowFlex = (props) => {
    return <div className={`flex flex-row ${props.className ? props.className : ""}`}>{props.children}</div>;
};

export default RowFlex;
